export default __webpack_public_path__ + "static/media/refresh.2393f92f.png";